/* eslint-disable @typescript-eslint/indent */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { TServerResponse } from 'app/types/server-response';
import { marketingAPIBase } from 'app/utilities/env';

import { TAdvert } from '../types/advert';
import { ApplyJobDTO, TJob } from '../types/careers';
import { NewsLetter, TNewsLetterDTO } from '../types/newsletter';

export const layoutAPISlice = createApi({
  reducerPath: 'layoutsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: marketingAPIBase,
  }),
  endpoints: (build) => ({
    postNewsletterSubscription: build.mutation<
      TServerResponse<NewsLetter>,
      TNewsLetterDTO
    >({
      query: (body) => ({
        url: '/newsletter',
        method: 'POST',
        body,
      }),
    }),

    getAds: build.query<TAdvert[], void>({
      query: () => '/ads',
      transformResponse: (res: TServerResponse<TAdvert[]>) => res.data,
    }),

    getOpenJobs: build.query<TJob[], void>({
      query: () => '/jobs/open',
      transformResponse: (res: TServerResponse<TJob[]>) => res.data,
    }),

    applyJob: build.mutation<unknown, ApplyJobDTO>({
      query: (body) => ({
        url: '/jobs/apply',
        method: 'POST',
        body,
      }),
      transformResponse: (res: TServerResponse<unknown>) => res.data,
    }),
  }),
});

export const {
  usePostNewsletterSubscriptionMutation,
  useGetAdsQuery,
  useApplyJobMutation,
  useGetOpenJobsQuery,
  useLazyGetAdsQuery,
  useLazyGetOpenJobsQuery,
} = layoutAPISlice;
